import { render, staticRenderFns } from "./SlotCard.vue?vue&type=template&id=50fba252&scoped=true&"
import script from "./SlotCard.vue?vue&type=script&lang=js&"
export * from "./SlotCard.vue?vue&type=script&lang=js&"
import style0 from "./SlotCard.vue?vue&type=style&index=0&id=50fba252&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fba252",
  null
  
)

export default component.exports